'use strict';

var imagesLoaded = require('imagesloaded'),
    util = require('./util'),
    validator = require('./validator');

function initQuickViewButtons() {

    // Initialize the quickView library

    function addEvents(EventTarget){

        // initialize local variables
        var imageContainer = $(EventTarget).find('.product-name-image-container');
        var $qvButton = $(imageContainer).find('#quickviewbutton');
        if ($qvButton.length === 0) {
            $qvButton = $('<a role="button" id="quickviewbutton" data-returnfocus="false" class="quickview" tabindex="0">' + Resources.QUICK_VIEW + '<i class="fa fa-arrows-alt" aria-label="quick view opens in a dialog"></i></a>');
        }
        var bottomPos = 10 + ($(imageContainer).height() - $(imageContainer).find('div.product-image').height());
        var cssProps = {};
        if($(imageContainer).closest('.you-may-like').length && $(imageContainer).closest('.slick-vertical').length){
            cssProps = {'width':'140px', 'bottom':bottomPos, 'line-height':'33px', 'height':'33px', 'padding':'0 0.5em'};
        }
        else if($(imageContainer).closest('.last-visited-section').length){
            cssProps = {'width':'190px', 'bottom':bottomPos};
        }
        else{
            cssProps = {'width':$(imageContainer).find('.thumb-link img').width() - 20, 'bottom':bottomPos};
        }
        var $link = $(EventTarget).find('.name-link');
        var productTypeValue = '';

        $qvButton.data('href', $link.attr('href'));
        $qvButton.attr({
            'title': $link.attr('title')
        }).appendTo(imageContainer);
        $qvButton.css(cssProps);
        
        $qvButton.off('keypress').on('keypress', function(e) {
            if(e.keyCode === 13){
                $(this).click();
            }
        });

        $qvButton.off('click').on('click', function(e) {
            //SC-404 WCAG When closing the Quick Shop dialog, focus should move to the product.
            $('a.quickview[data-returnfocus="true"]').attr('data-returnfocus','false');
            $(this).attr('data-returnfocus', 'true');
            $(this).closest('.name-link').focus();
        	util.createCookie('pidcgid', getPIDCGIDValue($(this).closest('.product-tile').data('itemid')));
            if ($(this).closest('.product-tile').hasClass('product-set')) {
                productTypeValue = 'product-set';
            } else {
                productTypeValue = 'normal-product';
            }
        	if(typeof (MERCH_UTILS) !== 'undefined') {
        		if(document.URL.indexOf("q=") != -1){
        			MERCH_UTILS.setProductFindingMethodCookie("site_search");
        		} else {
        			MERCH_UTILS.setProductFindingMethodCookie("browse");
        		}
        	}
            e.preventDefault();
            window.quickview.show({
                url: $(this).data('href'),
                source: 'quickview',
                productType: productTypeValue,
                callback: function() {
                	validator.init();                   
                    // WCAG added aria-modal
                    $('.ui-dialog.quick-view').attr({
                        'id': 'modal-quickview',
                        'aria-modal': 'true'
                    });
                     // closes QV modal on overlay click
                    $('.ui-widget-overlay').bind('click', function() {
                        $('#QuickViewDialog').dialog('close');
                        $('body').find('.zoomWindowContainer, .zoomContainer').remove();
                    });
                }
            });

            // We don't want the quickView to also launch the PDP --
            // so return false a pre-empt any link continuation
            return false;

        });
        $(EventTarget).off('mouseenter')
    }
    $('body').off('mouseenter keyup', '.tiles-container .product-tile, .search-result-items .product-tile, .cart-recommendations-tiles .product-tile').on('mouseenter keyup', '.tiles-container .product-tile, .search-result-items .product-tile, .cart-recommendations-tiles .product-tile', function() {
    	 if( !(($(this).hasClass('product-set')) || $(this).hasClass('specialproductset')) && !$(this).find('#quickviewbutton').length && $(this).parents('li.grid-tile:not(.one-space-tile):not(.two-space-tile)').length) {
            addEvents(this);
    	}
    });

    $('body').off('mouseenter keyup','.einstien-recommendations-container .product-tile:not(.specialproductset)').on('mouseenter keyup', '.einstien-recommendations-container .product-tile:not(.specialproductset)', function() {
        addEvents(this);
    });
}

function gridViewToggle() {
    $('.toggle-grid').on('click', function() {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}


function swatchesHover() {

	if (window.matchMedia("(min-width: 1024px)").matches) {
	    // Show swatches on mouse-enter / enter
	    $('.product-swatches').on('mouseenter', function(e) {
	        e.preventDefault();
	        if ($(this).hasClass('show-color')) { return; }
            $(this).addClass('show-color');
            $(this).find("img").trigger('unveil');
            
	    });

	    // Hide swatches on mouse-leave / exit
	    $('.product-swatches').on('mouseleave', function(e) {
	        e.preventDefault();
	        if (!$(this).hasClass('show-color')) { return; }
            $(this).removeClass('show-color');
	    });
	}

    // Show swatches on 'click' of the colors link
    $('.product-swatches-all-showless').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.product-swatches').removeClass('show-color');
    });

    // Hide swatches on 'click' of the close link
    $('.product-swatches-all').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.product-swatches').addClass('show-color');
        $(this).closest('.product-swatches').find("img").trigger('unveil');
    });

}

/**
 * @function getPIDCGIDValue
 * @description generates the pidcgid cookie value (checks for a valid cgid and uses it to render the cookie-value)
 */
function getPIDCGIDValue(pid) {
    var cgid = $('#search-result-items').data('cgid') || '';
    return pid + '|' + encodeURIComponent(cgid);
}

/**
 * @function initializeEvents
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    gridViewToggle();
    swatchesHover();
    if(SitePreferences.SHOW_QUICK_VIEW){	
		initQuickViewButtons();		
	}
    if($('.refinements').length !== 0) {       
        $('.refinements').addClass('ws-sticky').trigger('wssticky') 
    }

    $('.p-image-rollover').hover(function() {
        $(this).css('cursor', 'pointer');
    });
    $('.p-image').hover(function() {
        $(this).css('cursor', 'pointer');
    });
    $('.swatch-list').on('mouseleave', function() {
        // Restore current thumb images
        var $tile = $(this).closest('.product-tile'),
            $thumbs = $tile.find('.product-image .thumb-link img'),
            current = $thumbs.eq(0).data('current'),
            currentHover = $thumbs.eq(1).data('current');

        if (current) {
            $thumbs.eq(0).attr({
                src: current.src,
                alt: current.alt,
                title: current.title
            });
        }

        if (currentHover) {
            $thumbs.eq(1).attr({
                src: currentHover.src,
                alt: currentHover.alt,
                title: currentHover.title
            });
        }

    });
    $('.swatch-list .swatch').on('click', function(e) {
        e.preventDefault();

        // Enable swatch toggling on swatch-clicks for mobile
        if (!$(this).closest('.product-swatches').hasClass('show-color')) {
            $(this).closest('.product-swatches').addClass('show-color');
            $(this).closest('.product-swatches').find("img").trigger('unveil');
        }

        if ($(this).hasClass('selected')) {
            return;
        }

        var $tile = $(this).closest('.product-tile');        
        var hrefAddress = $(this).data('href');
        var $title = $(this).attr("title");

        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');

        // WCAG - added dynamic selected text before swatch name
        $(this).closest('.swatch-list').find('.swatch').attr('aria-label', $title);
        $(this).attr('aria-label','selected '+ $title);

        $tile.find('name-link').attr('href', hrefAddress);

        var $thumbs = $tile.find('.product-image .thumb-link img');
        var data = $(this).children('img').filter(':first').data('thumb');
        var dataHover = $(this).children('img').filter(':first').data('thumb-hover');

        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };

        var currentHoverAttrs = {
            src: dataHover.src,
            alt: dataHover.alt,
            title: dataHover.title
        };

        $thumbs.eq(0).attr(currentAttrs);
        $thumbs.eq(0).data('current', currentAttrs);
        $thumbs.eq(1).attr(currentHoverAttrs);
        $thumbs.eq(1).data('current', currentHoverAttrs);

        // Update all productUrls with the active swatch
        updateProductUrls($tile, $(this));

    }).on('mouseenter', function() {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumbs = $tile.find('.product-image .thumb-link img'),
            data = $(this).children('img').filter(':first').data('thumb'),
            dataHover = $(this).children('img').filter(':first').data('thumb-hover'),
            current = $thumbs.eq(0).data('current'),
            currentHover = $thumbs.eq(1).data('current');

        // If this is the first time, then record the current img
        if (!current) {
            $thumbs.eq(0).data('current', {
                src: $thumbs[0].src,
                alt: $thumbs[0].alt,
                title: $thumbs[0].title
            });
        }

        // Only evaluate this if more than one thumb was found
        if ($thumbs.length > 1) {

            if (!currentHover) {
                $thumbs.eq(1).data('current', {
                    src: $thumbs[1].src,
                    alt: $thumbs[1].alt,
                    title: $thumbs[1].title
                });
            }

        }

        // Set the tile image to the values provided on the swatch data attributes
        $thumbs.eq(0).attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });

        // Only evaluate this if more than one thumb was found
        if ($thumbs.length > 1) {

            $thumbs.eq(1).attr({
                src: dataHover.src,
                alt: dataHover.alt,
                title: dataHover.title
            });

        }

    });

    // Capture and thumbnail / product-name link-clicks, and use them to
    // set the PIDCGID cookie value prior to re-directing the user to the PDP
    $('.thumb-link, .name-link').on('click', function(){

        // Initialize local variables
        var $nameLink = $(this);
        var $tile = $nameLink.closest('.product-tile');
        var pid = $tile.data('itemid');
        var catId = $('.currentcategory').val();
        var $viewMoreLink = $('.viewmore-grid').last();

        // Exit early if this tile has no product defined
        if (pid === undefined || pid === ''){
            return;
        }

        // Next, set all of the product / grid-based cookies for the PLP display
        // For the viewLink, make sure we get the LAST view-more url used
        util.createCookie('viewLink', $viewMoreLink.attr('href'));
        util.createCookie('productId', pid);
        util.createCookie('categoryId', catId);
        util.createCookie('pidcgid', getPIDCGIDValue(pid));

    });

    if ($(window).width() > 1024) {
        $('.thumb-link').hover(function() {
            $(this).find('.p-image-rollover').show().siblings('img').hide();
        }, function() {
            $(this).find('.p-image-rollover').hide().siblings('img').show();
        });
    }
    if ($(window).width() > 1024) {
        if ($('.slot-grid-header').length > 0 && $('.slot-grid-header').children().length === 0 ){
            $('.pt_product-search-result').find('.breadcrumb').addClass('nobanner-slot');
            $('.pt_product-search-result').find('.refinements').addClass('banner-slot');
        }
    }

    if(!$('.slot-grid-header .standard-contentslot').children().length == 0) {
    	$('.pt_product-search-result').find('.content-banner-breadcrumb').addClass('absolute');
    }
    else {
        $('.slot-grid-header').addClass('no-category-banner');
    }

    var $ptsearchresult = $('.pt_product-search-result');
    if ($ptsearchresult.find('.standard-contentslot').length > 0 && $ptsearchresult.find('.standard-contentslot').find('img').length > 0){
        $ptsearchresult.find('.standard-contentasset').remove();
    } else {
        $ptsearchresult.find('.standard-contentasset').show();
    }

    $('.dropdown-overlay').off('click').on('click',function() {
    	if ($(window).width() < 1024) {
    		$('.sort-by').removeClass('current_item');
    	}
    });
    
    /* WCAG PDP structure */
    $(window).resize(function () {        
        if($(window).width() < 768){
            if($("#zoom-image-container").hasClass('top-wrap')) {
            	$("#pdp-image-container").insertAfter("#zoom-image-container");
            }      
        } else{
	        	if($("#zoom-image-container").hasClass('top-wrap')) {
	        		$("#zoom-image-container").insertAfter("#pdp-image-container");
	        	}
        	}
    });
}

/**
 * @private
 * @function updatePDPLinkParameters
 * @description Takes a swatch link element and updates the PDP url to hash-enable the url, and
 * updates the name-link href with the updated / constructed url value.
 *
 * @param {Object} linkElement represents the jQuery instance of a link anchor
 */
function updatePDPLinkParameters(linkElement){

    // Initialize local variables
    var $element;           // Working variable that represents the clicked-on element
    var $tile;              // Parent reference to the grid-tile being interacted with
    var $nameLink;          // Reference to the productName-link (.name-link) containing the PDP url for a product
    var elementHref;        // Working variable reference to the existing href / url to copy the params to
    var wl;                 // Reference to the window.location property
    var qsHashParams;       // Holding variable to contain the existing productDetail url's queryString hash parameters
    var qsParams;           // Holding variable to contain the element's queryString parameters
    var hashParams;         // Holding variable to contain the element's hash parameters
    var params;             // Working variable that represents the 'final' collection of queryString parameters
    var idx;                // Determines the location of the current productTile in the overall results
    var finalHashParams;    // Stores the final collection of merged hash parameters between the element and nameLink urls


    if(typeof linkElement === 'undefined' || linkElement.length === 0) {
        return;
    }

    // Create the jQuery-wrapped objects
    $element = $(linkElement);
    $tile = $element.closest('.product-tile');
    $nameLink = $tile.find('.name-link');

    // Get the href attached to this link element
    elementHref = $element.attr('href');

    // Was a valid href value found?
    if (elementHref === undefined) {

        // If not, then get the href from the nameLink
        elementHref = $nameLink.attr('href');

    }

    // Get current page refinement values
    wl = window.location;
    qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
    hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

    // Get the existing url hash values
    qsHashParams = util.getQueryStringHashParams(elementHref);

    // Merge hash params with querystring params
    params = $.extend(hashParams, qsParams);
    params = $.extend(params, qsHashParams);

    // Has a start property been defined?
    if (!params.start) {

        // Default the start property
        params.start = 0;

    }

    // Get the index of the selected item and save as start parameter
    idx = $tile.data('idx') ? + $tile.data('idx') : 1;

    // Convert params.start to integer and add index
    params.start = (idx);

    // Generate the final hash
    finalHashParams = $.param(params);

    // Update the hash-values for the element link (if it's an anchor)
    if ($element.is('a')) {
        $element[0].hash = finalHashParams;
    }

    // With the url re-written, now go ahead and
    // update the nameLink with the selected swatchUrl
    $nameLink[0].hash = finalHashParams;
    $nameLink.attr('href', $element.attr('href'));

}

/**
 * @private
 * @function updateProductUrls
 * @description Takes the product-detail url attached to a given swatch, and updates all pdp-clickable
 * tile-elements with the selected swatch / variant pdp-url.
 *
 * @param {Object} $tile represents the jQuery instance of a productTile
 * @param {Object} $swatch represents the jQuery instance of the active / selected swatch
 */
function updateProductUrls($tile, $swatch) {

    // Initialize local variables
    var $nameLink;          // Represents the productName container-element
    var $tileImage;         // Represents the tile-image container-element
    var variantHref;        // Represents the productDetail link for the selected variant

    // Default the productDetail link for the current swatch
    variantHref = $swatch.data('href');

    // Create references to the tile-elements we need to update
    $nameLink = $tile.find('.name-link');
    $tileImage = $tile.find('.product-image');

    // Update the related productUrls with the swatchUrl
    $nameLink.attr('href', variantHref);
    $tileImage.closest('.product-name-image-container').find('.quickview').data('href', variantHref);
}


// Export the pdpLink update function so we can call is from search.js
exports.updatePDPLinkParameters = updatePDPLinkParameters;

// Export the init function so that gridTiles can be initialized from the PLP
exports.init = function() {

    // Initialize all events
    initializeEvents();

    // Retrieve all the productTiles on the page
    var $tiles = $('.tiles-container').not('.recommendation-tiles').find('.product-tile');

    // If no tiles are found, exit early
    if ($tiles.length === 0) {
        return;
    }

    // Attach a a global on-load / error handler to tile-images
    $('.p-image, .p-image-rollover').on('error', function() {

        // Initialize local variables
        var $img = $(this);

        // Reset the image source for the product-image being displayed
        $img.attr('src', window.product404Images.tileImage);

    });

    // Otherwise, sync the height of all the tiles
    imagesLoaded('.tiles-container').on('done', function() {
        $tiles.syncHeight();
    });
    //force trigger lazyload
	$(window).resize();
};
